<div class="empty-state-wrapper">
  <bw-icon-legacy [iconName]="iconName" horizontalSpace="mb-sm" color="var(--disabled-text)" size="32"></bw-icon-legacy>
  <typography-legacy headline-semibold class="secondary-text mb-sm">{{primaryCopy}}</typography-legacy>
  <typography-legacy text-medium-regular class="secondary-text mb-smd">{{secondaryCopy}}</typography-legacy>
  <ng-content select="button"></ng-content>
</div>
